/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index';

let exports = {};
//分类品牌
exports.getGoodsCatBrandListByCatId = function (params, callback) {// 根据分类id获取分类品牌列表
    api.post('/goods/categ/brand/list/get/by/catId')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};
// 查询商品分类树列表
exports.getGoodsCatTreeList = function (params, callback) {
    api.post('/goods/categ/tree/list/get')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};
// 查询商品分类树列表
exports.getImplGoodsCatTreeList = function (params, callback) {
    api.post('/shop/device/impl/tree/list/get')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};
// 查询商品分类树列表
exports.getGoodsCatTreeListByFilter = function (params, callback) {
    api.post('/goods/categ/tree/list/get/by/filter')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};
// 查询商品分类树列表
exports.getImplGoodsCatTreeListByFilter = function (params, callback) {
    api.post('/shop/device/tree/import/list/get/by/filter')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};
// 获取商品分类列表
exports.getGoodsCatList = function (params, callback) {
    api.post('/goods/categ/list/get')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};
// 根据parentId获取商品分类列表
exports.getGoodsCatListByParentId = function (params, callback) {
    api.post('/goods/categ/list/get/by/parentId')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};

// ================ 评价 ====================

// 获取标签
exports.getGoodsCatEvalTagList = function (postData, callback) {// 获取评价标签列表
    api.post('/goods/categ/eval/tag/list/get')
        .data(postData)
        .done(callback)
        .go();
};

// ================== 个人资质-对服务商的人员资质要求 ======================

exports.getStaffQualiClaimToServicerPageList = function (postData, callback) {// 对服务商的人员资质要求-分页列表
    api.post('/goods/categ/staff/quali/claim/to/servicer/page/list')
        .data(postData)
        .done(callback)
        .go();
};

exports.getStaffQualiClaimToServicerList = function (postData, callback) {// 对服务商的人员资质要求-列表
    api.post('/goods/categ/staff/quali/claim/to/servicer/list')
        .data(postData)
        .done(callback)
        .go();
};

exports.saveStaffQualiClaimToServicer = function (postData, callback) {// 对服务商的人员资质要求-新增
    api.post('/goods/categ/staff/quali/claim/to/servicer/save/do')
        .data(postData)
        .done(callback)
        .go();
};

exports.updateStaffQualiClaimToServicer = function (data, callback) {// 对服务商的人员资质要求-修改
    api.post('/goods/categ/staff/quali/claim/to/servicer/update/do')
        .data(data)
        .done(callback)
        .go();
};

exports.deleteStaffQualiClaimToServicer = function (params, callback) {// 对服务商的人员资质要求-删除
    api.post('/goods/categ/staff/quali/claim/to/servicer/delete/do')
        .params(params)
        .done(callback)
        .go();
};
exports.getStaffQualiClaimToServicerServcTypeId = function (data, callback) {// 对服务商的人员资质要求-删除
    api.post('/goods/categ/staff/quali/claim/to/servicer/get/servcTypeId')
        .data(data)
        .done(callback)
        .go();
};

// ================== 个人资质-对服务商的人员资质要求（常规） ======================

exports.getStaffQualiClaimToServicer2PageList = function (postData, callback) {// 对服务商的人员资质要求-分页列表
    api.post('/goods/categ/staff/quali/claim/to/servicer2/page/list')
        .data(postData)
        .done(callback)
        .go();
};

exports.getStaffQualiClaimToServicer2List = function (postData, callback) {// 对服务商的人员资质要求-列表
    api.post('/goods/categ/staff/quali/claim/to/servicer2/list')
        .data(postData)
        .done(callback)
        .go();
};

exports.saveStaffQualiClaimToServicer2 = function (postData, callback) {// 对服务商的人员资质要求-新增
    api.post('/goods/categ/staff/quali/claim/to/servicer2/save/do')
        .data(postData)
        .done(callback)
        .go();
};

exports.updateStaffQualiClaimToServicer2 = function (data, callback) {// 对服务商的人员资质要求-修改
    api.post('/goods/categ/staff/quali/claim/to/servicer2/update/do')
        .data(data)
        .done(callback)
        .go();
};

exports.deleteStaffQualiClaimToServicer2 = function (params, callback) {// 对服务商的人员资质要求-删除
    api.post('/goods/categ/staff/quali/claim/to/servicer2/delete/do')
        .params(params)
        .done(callback)
        .go();
};
exports.getStaffQualiClaimToServicer2ServcTypeId = function (data, callback) {// 对服务商的人员资质要求-删除
    api.post('/goods/categ/staff/quali/claim/to/servicer2/get/servcTypeId')
        .data(data)
        .done(callback)
        .go();
};

// ====================== 设备分组 =======================

// 获取设备分组列表
exports.getDevcGroupList = function (data, callback) {
    api.post('/goods/categ/devc/group/list/get')
        .data(data)
        .done(callback)
        .go();
};

exports.getDevcGroupListByFilter = function (data, callback) {
    api.post('/goods/categ/devc/group/noPages/list/get')
        .data(data)
        .done(callback)
        .go();
};

// 根据ID获取设备分组
exports.getDevcGroup = function (params, callback) {
    api.get('/goods/categ/devc/group/get')
        .params(params)
        .done(callback)
        .go();
};

// 保存设备分组
exports.saveDevcGroup = function (data, callback) {
    api.post('/goods/categ/devc/group/save/do')
        .data(data)
        .done(callback)
        .go();
};

// 删除设备分组
exports.deleteDevcGroup = function (params, callback) {
    api.post('/goods/categ/devc/group/delete/do')
        .params(params)
        .done(callback)
        .go();
};

// 获取指定分组下商品分类设备分组中商品分类id列表
exports.getGoodsCatDevcGroupCatIdList = function (params, callback) {
    api.get('/goods/categ/goods/cat/devc/group/catId/list/get')
        .params(params)
        .done(callback)
        .go();
};

// 获取商品分类设备分组分页列表
exports.getGoodsCatDevcGroupPageList = function (data, callback) {
    api.post('/goods/categ/goods/cat/devc/group/page/list/get')
        .data(data)
        .done(callback)
        .go();
};

// 获取商品分类设备分组列表
exports.getGoodsCatDevcGroupList = function (data, callback) {
    api.post('/goods/categ/goods/cat/devc/group/list/get')
        .data(data)
        .done(callback)
        .go();
};
// 获取商品分类设备分组列表-同步方法
exports.getGoodsCatDevcGroupListForSync = function (data, callback) {
    api.get('/goods/categ/goods/cat/devc/group/list/sync/get')
        .sync(true)
        .params(data)
        .done(callback)
        .go();
};

// 获取指定分组下商品分类设备分组中商品分类id列表
exports.saveGoodsCatDevcGroupBatch = function (data, callback) {
    api.post('/goods/categ/goods/cat/devc/group/batch/save/do')
        .data(data)
        .done(callback)
        .go();
};

//
exports.deleteGoodsCatDevcGroupBatch = function (data, callback) {    // 移除分类分分组关联分类
    api.post('/goods/categ/goods/cat/devc/group/batch/delete/do')
        .data(data)
        .done(callback)
        .go();
};

exports.getGoodsCatDevcGroupListByCatId = function (params, callback) {// 根据分类查询设备分类分组
    api.get('/goods/categ/devc/group/by/catId')
        .params(params)
        .done(callback)
        .go();
};

exports.getDevcGroupTreeList = function (data, callback) {    // 获取分类分组树列表
    api.post('/goods/categ/devc/group/tree/list/get')
        .data(data)
        .done(callback)
        .go();
};

exports.getDevcGroupPartPageList = function (data, callback) { // 获取设备分组部件列表
    api.post('/goods/categ/devc/group/part/list/get')
        .data(data)
        .done(callback)
        .go();
};

exports.deleteDevcGroupPart = function (data, callback) { // 删除设备分组部件
    api.post('/goods/categ/devc/group/part/delete/do')
        .data(data)
        .done(callback)
        .go();
};


export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/goodsCateg.js
// module id = 45
// module chunks = 0